import { strings } from './Strings/strings';
import LocalizedStrings from 'react-localization';

export const string = new LocalizedStrings(strings);
